module.exports = __webpack_public_path__ + "static/media/lmu-final-year-project.4688b432.md";